import { compose, branch } from "recompose";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { fetchApi } from "core/api/hoc";
import * as hoc from "modules/user/auth/hoc";
import { isInsider } from "modules/user/auth/model";
import * as bookingApi from "modules/booking/api";
import * as feedbackApi from "modules/feedback/api";
import * as bookingSelectors from "modules/booking/selectors";
import * as feedbackSelectors from "modules/feedback/selectors";
import View from "./View";

export default compose(
  hoc.authorized(isInsider),
  withRouter,
  fetchApi(bookingApi.getBookedCallDetail, ({ match }) => ({
    payload: {
      id: match.params.id
    },
    selector: bookingSelectors.getBookedCallDetailApi,
    key: "call",
    sync: true
  })),
  connect(
    createStructuredSelector({
      call: bookingSelectors.fetchCallDetails
    })
  ),
  branch(
    props => props.call.status === "Settled",
    fetchApi(feedbackApi.getCandidateFeedback, ({ match, call }) => ({
      payload: {
        bookingId: call.id,
        targetId: call.candidate.id
      },
      selector: feedbackSelectors.getCandidateFeedbackApi,
      key: "feedback",
      sync: true
    }))
  )
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/CallDetail/Provider.js